module.exports = __webpack_public_path__ + "img/XEM.6bf69552.svg";